import { useCallback, useMemo } from "react";
import ModelTag from "../../components/model-tag";

interface CustomizationFilterBadgeToggleProps {
    /** The label to display in the badge */
    label: string;
    /** All tags that are currently active */
    allActiveTags: string[];
    /** Callback when the badge is toggled */
    onToggle: (label: string) => void;
    /** Optional `data-testid` forwarded to the underlying badge — for e2e tests that
     *  need to target a specific tag badge by stable selector. */
    testId?: string;
}

const CustomizationFilterBadgeToggle = (props: CustomizationFilterBadgeToggleProps) => {
    const { label, allActiveTags, onToggle, testId } = props;

    const isActive = useMemo(() => allActiveTags.includes(label), [allActiveTags, label]);

    const handleClick = useCallback(() => {
        onToggle(label);
    }, [label, onToggle]);

    return (
        <ModelTag isActive={isActive} onClick={handleClick} testId={testId}>
            {label}
        </ModelTag>
    );
}

export default CustomizationFilterBadgeToggle;
